import Apicall from '../rest/Apicall';


export const loginByAuth = async (email, password) => {    
    const token = await Apicall.loginByAuth(email, password);
    localStorage.setItem('token', token);
    document.getElementById('root').classList.remove('login-page');
    document.getElementById('root').classList.remove('hold-transition');
    //console.log("token: "+token);
    return token;
};

export const registerByAuth = async (email, password) => {
    const token = await Apicall.registerByAuth(email, password);
    localStorage.setItem('token', token);
    document.getElementById('root').classList.remove('register-page');
    document.getElementById('root').classList.remove('hold-transition');
    return token;
};
